import { render, staticRenderFns } from "./prices-icon.vue?vue&type=template&id=b41691de&scoped=true&"
import script from "./prices-icon.vue?vue&type=script&lang=js&"
export * from "./prices-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b41691de",
  null
  
)

export default component.exports